import http from './httpService';
import config from './../config.json';

export const getCaptcha = ({cancelToken}) => {
	return http.get(config.api_captcha, {cancelToken});
}